export default {
	AUTH: 'v2/session',
	LISTS: {
		ALL: 'v2/lists'
	},
	LOOKUPS: {
		PRODUCTS: 'v2/lookups/products',
		OFFERS: 'v2/lookups/offers',
		OFFERS_CATEGORIES: 'v2/lookups/offer-categories',
		OFFERS_NICHES: 'v2/lookups/offer-niches',
		OFFERS_GEO: 'v2/lookups/offer-geo',
		OFFERS_CATEGORIES_RP: 'v2/lookups/offer-categories-rp',
		AFFILIATES: 'v2/lookups/affiliates',
		UTM_SOURCE: 'v2/lookups/utms/utm_source',
		UTM_MEDIUM: 'v2/lookups/utms/utm_medium',
		AFFILIATE_IDS: 'v2/lookups/affiliate-ids',
		CAMPAIGN_DOMAINS: 'v2/lookups/campaign-domains',
		ADMINS: 'v2/lookups/admins',
		REGIONS: 'v2/lookups/regions',
		LOCATIONS: 'v2/lookups/locations',
		LOCATIONS_WITH_TRAFFIC: 'v2/lookups/locations-with-traffic',
		LOCATION_CODES_WITH_TRAFFIC: 'v2/lookups/location-codes-with-traffic',
		OFFER_TAGS: 'v2/lookups/offer-tags',
		LOCATION_CODES: 'v2/lookups/location-codes',
		LEAD_SOURCES: 'v2/lookups/lead-sources',
		CITIES: 'v2/lookups/cities',
		OFFER_DEFAULT_GEO: 'v2/lookups/offer-default-geo',
		REFERER_DOMAINS: 'v2/lookups/referer-domains',
		AFFILIATE_TAGS: 'v2/lookups/affiliate-tags',
		PAYOUT_SYSTEMS: 'v2/lookups/payout-systems',
		CAMPAIGNS: 'v2/lookups/campaigns',
		LOCATIONS_BY_COUNTRY: 'v2/lookups/locations_by_country',
		CONVERSIONS_GEOS: 'v2/affiliates/{id}/conversions_geos',
		UTM_TAGS: 'v2/lookups/utm-tags/{tag}',
		DASHBOARD_REFERERS: 'v2/lookups/dashboard-referers',
		BANNER_CONTENTS: 'v2/lookups/banners/contents',
		GOOD_CATEGORIES: 'v2/lookups/good-categories',
		BM_ACCOUNTS_CATEGORIES: 'v2/lookups/bm-accounts-categories',
		CONVERSION_NAMES: 'v2/lookups/conversion-names',
		SIDS: 'v2/lookups/sids',
		CONVERSION_PHONES: 'v2/lookups/conversion-phones',
		ARTICLE_TAGS: 'v2/lookups/article-tags',
		STATUS_CHANGED_AT: 'v2/lookups/status-changed-at',
		AFFILIATE_LANDING_DOMAINS: 'v2/lookups/affiliate_landing_domains',
		ALERT_EVENTS: 'v2/lookups/alert-events'
	},
	ADMINS_LIST: 'v2/admins',
	ADMINS_CLONE: 'v2/admins/clone',
	ADMIN_DISTRIBUTE_AFFILIATES: 'v2/admins/{id}/distribute-affiliates',
	ADMIN_PROFILE: 'v2/profile',
	EXCHANGE_RATE: 'v2/exchange-rates',
	UNACCEPTABLE_CONVERSIONS: {
		BASE: 'v2/unacceptable-conversions'
	},
	STATISTICS: {
		GENERAL: 'v2/analytics/general',
		INVALID: 'v2/analytics/invalid',
		CONVERSIONS: 'v2/analytics/conversions',
		UNACCEPTABLE_CONVERSIONS: 'v2/analytics/unacceptable-conversions',
		RESENDED_AUTOTRASH: 'v2/analytics/resent-autotrash/:id',
		RESEND_BANNED_LEADS: 'v2/analytics/resend-banned-leads',
		FILTERS: {
			IDS: 'v2/analytics/lists/ids',
			CRM_IDS: 'v2/analytics/lists/crm_id',
			OFFERS: 'v2/analytics/lists/offers',
			AFFILIATES: 'v2/analytics/lists/affiliates',
			AFFILIATE_COUNTRIES: 'v2/analytics/lists/affiliate_countries',
			LANDINGS: 'v2/analytics/lists/landings',
			LANDING_DOMAINS: 'v2/analytics/lists/landing_domains',
			TRANSIT_DOMAINS: 'v2/analytics/lists/transit_domains',
			TRANSITS: 'v2/analytics/lists/transits',
			COUNTRIES: 'v2/analytics/lists/countries',
			CITIES: 'v2/analytics/lists/cities',
			CAMPAIGNS: 'v2/analytics/lists/campaigns',
			CAMPAIGNS_TYPES: 'v2/analytics/lists/campaign-types',
			TRAFFIC_TYPES: 'v2/analytics/lists/traffic-types',
			SIDS1: 'v2/analytics/lists/sids1',
			SIDS2: 'v2/analytics/lists/sids2',
			SIDS3: 'v2/analytics/lists/sids3',
			SIDS4: 'v2/analytics/lists/sids4',
			SIDS5: 'v2/analytics/lists/sids5',
			SPLIT_SESSIONS: 'v2/analytics/lists/split_sessions',
			MANAGERS: 'v2/analytics/lists/managers',
			SALEMODELS: 'v2/analytics/lists/sale_models',
			TRAFFIC_SOURCES: 'v2/analytics/lists/traffic_sources',
			REFERER_DOMAINS: 'v2/analytics/lists/referer_domains'
		}
	},
	CHAINS: {
		BASE: 'v2/chains',
		NEED_TO_UPDATE_COUNT: 'v2/chains/need_to_update',
		FILTERS: {
			OFFERS: 'v2/chains/lists/offers',
			AFFILIATES: 'v2/chains/lists/affiliates',
			LANDINGS: 'v2/chains/lists/landings',
			TRANSITS: 'v2/chains/lists/transits',
			COUNTRIES: 'v2/chains/lists/countries',
			STATUSES: 'v2/chains/lists/affiliate_statuses'
		}
	},
	ALERTS: {
		BASE: 'v2/alerts'
	},
	CAMPAIGN_DOMAINS_LIST: 'v2/campaign-domains',
	OFFERS: {
		BASE: 'v2/offers',
		EXPORT_STOCK: 'v2/offers/stock',
		SORT: 'v2/offers/sort',
		UPLOAD_OFFER_IMAGE: 'v2/offers/{id}/image',
		BASE_TRANSLATION: 'v2/offers/{id}/translation/{lang}',
		LANDINGS: 'v2/offers/{id}/landings',
		LANDINGS_DELETE: 'v2/offers/landings/{id}',
		LANDINGS_TRANSLATION: 'v2/offers/{id}/landings/translations/{lang}',
		TARGETING: 'v2/offers/{id}/targeting',
		MAX_PAYOUT: 'v2/offers/{id}/max-geo-payout',
		PAYOUT_CHANGE_REASON_IMAGE: 'v2/offers/change-image',
		UPLOAD_PROMO: 'v2/offers/{id}/upload-promo',
		GRAND_ACCESS: 'v2/offers/{id}/grant-access',
		REVOKE_ACCESS: 'v2/offers/{id}/revoke-access',
		INDIVIDUAL_TERMS: 'v2/offers/{id}/individual-terms',
		LOCATION_RESTRICTIONS: 'v2/offers/{id}/location-restrictions',
		LOCATION_RESTRICTIONS_DELETE: 'v2/offers/location-restrictions/{id}',
		LOCATION_RESTRICTIONS_TRANSLATIONS: 'v2/offers/{id}/location-restrictions/translations/{lang}'
	},
	OFFER_CATEGORIES: {
		BASE: 'v2/offer-categories'
	},
	THREADS: {
		LIST: 'v2/threads',
		UPLOAD: 'v2/threads/{postId}/attachments',
		CLOSE: 'v2/threads/{id}/close',
		PAUSE: 'v2/threads/{id}/pause',
		UNPAUSE: 'v2/threads/{id}/unpause',
		UNREAD_COUNT: 'v2/threads/unread'
	},
	EXTERNAL_THREADS: {
		LIST: 'v2/external-threads',
		UPLOAD: 'v2/external-threads/{postId}/attachments',
		CLOSE: 'v2/external-threads/{id}/close',
		PAUSE: 'v2/external-threads/{id}/pause',
		UNPAUSE: 'v2/external-threads/{id}/unpause',
		UNREAD_COUNT: 'v2/external-threads/unread'
	},
	AFFILIATES: {
		BASE: 'v2/affiliates',
		LOGIN: 'v2/affiliates/{id}/login',
		PENDING_OFFER: 'v2/affiliates/{id}/pending-offer-access-requests',
		TOTAL_DEBT: 'v2/affiliates/total-debt',
		PAYOUT_SETTINGS: 'v2/affiliates/{id}/payout-settings',
		PAYOUT_SETTING: 'v2/affiliates/{id}/payout-settings/{payout_setting_id}',
		ACTIVITY: '/v2/affiliates/actitivity-report',
		INDIVIDUAL_TERMS: 'v2/affiliates/{id}/individual-offer-terms',
		LOGS: 'v2/affiliates/{id}/logs',
		NOTES: 'v2/affiliates/{id}/notes',
		UPLOAD: 'v2/affiliates/{id}/attachment',
		MASTER_ACCOUNT: 'v2/master-account',
		REDEEM: 'v2/affiliates/redeem',
		ADD_NEW_LEAD_SOURCE: 'v2/affiliates/lead-source',
		TRANSFER_BALANCE_AND_ACCUMULATED_POINTS: 'v2/affiliates/transfer-balance-and-accumulated-points',
		POINTS_TRANSACTION: 'v2/affiliates/{id}/points-transactions',
		COPY_OFFER: 'v2/affiliates/{id}/copy-offer',
		SESSIONS_DELETE: 'v2/affiliates/{id}/sessions-delete',
		CONFIRMATION_LINK: 'v2/affiliates/{id}/confirmation-link',
		SEND_CONFIRMATION_EMAIL: 'v2/affiliates/send-confirmation-email'
	},
	APPLICANTS: {
		BASE: 'v2/applicants',
		LOGS: 'v2/applicants/{id}/logs',
		UPLOAD_APPLICANT_IMAGE: 'v2/applicants/{id}/image',
		REGISTRATION: 'v2/applicants/registration',
		FILTERS: {
			AFFILIATES: 'v2/applicants/lists/affiliates',
			MANAGERS: 'v2/applicants/lists/managers',
			COUNTRIES: 'v2/applicants/lists/countries'
		}
	},
	GOODS: {
		BASE: 'v2/goods',
		SINGLE: 'v2/goods/{id}',
		UPLOAD_GOODS_IMAGE: 'v2/goods/{id}/image'
	},
	GOOD_CATEGORIES: {
		BASE: 'v2/good-categories'
	},
	MISSIONS: {
		BASE: 'v2/missions',
		SINGLE: 'v2/missions/{id}',
		UPLOAD_MISSION_IMAGE: 'v2/missions/{id}/image'
	},
	ACHIEVEMENTS: {
		BASE: 'v2/achievements',
		SINGLE: 'v2/achievements/{id}',
		UPLOAD_ACHIEVEMENTS_IMAGE: 'v2/achievements/{id}/image'
	},
	BM_ACCOUNTS: {
		BASE: 'v2/bm-accounts',
		SINGLE: 'v2/bm-accounts/{id}',
		UPLOAD_IMAGE: 'v2/bm-accounts/{id}/image'
	},
	BM_ACCOUNTS_CATEGORIES: {
		BASE: 'v2/bm-account-categories'
	},
	NEWS: {
		BASE: 'v2/news',
		BASE_TRANSLATION: 'v2/news/{id}/translation/{lang}'
	},
	DISCOUNTS: {
		BASE: 'v2/partner-discounts',
		BASE_IMAGE: 'v2/partner-discounts/{id}/image',
		DISCOUNT_TERM: 'v2/partner-discounts/{id}/term',
		SINGLE: 'v2/partner-discounts/{id}'
	},
	PAYOUTS: {
		BASE: 'v2/payouts',
		REJECT: 'v2/payouts/reject',
		APPROVE: 'v2/payouts/approve',
		CONFIRM: 'v2/payouts/confirm',
		CHANGE_URGENCY: 'v2/payouts/{payout_setting_id}/{urgency}',
		ADMIN_TRANSACTION: 'v2/payouts/admin-transaction',
		TRANSFERS: 'v2/payouts/transfers',
		LOGS: 'v2/payouts/logs'
	},
	PAYOUT_SYSTEMS: {
		BASE: '/v2/payout-systems',
		LIST: '/v2/payout-systems',
		BALANCE_INFO: 'v2/payout-systems/{id}/balance',
		TRANSLATIONS: '/v2/payout-systems/{id}/translation/{lang}',
		SORT: 'v2/payout-systems/sort'
	},
	PAYOUT_REQUESTS: {
		BASE: '/v2/payout-requests',
		CURRENT_PAYOUT: '/v2/payout-requests/current-payout',
		MAX_WEEKLY_CONVERSIONS: '/v2/payout-requests/max-weekly-leads',
		COUNT: '/v2/payout-requests/count',
		HISTORY: '/v2/payout-requests/history',
		REGISTER: '/v2/payout-requests/register',
		STAT: '/v2/payout-requests/stat',
		SINGLE: '/v2/payout-requests/{id}',
		REVIEW: '/v2/payout-requests/{id}/review',
		RESUBMIT: '/v2/payout-requests/{id}/resubmit',
		APPROVE: '/v2/payout-requests/{id}/approve',
		REJECT: '/v2/payout-requests/{id}/reject',
		LOOKUP_OFFERS: '/v2/payout-requests/lookup/offers',
		LOOKUP_SIDS: '/v2/payout-requests/lookup/sids',
		LOOKUP_LOCATIONS: '/v2/payout-requests/lookup/locations',
		ACCEPT: '/v2/payout-requests/{id}/accept'
	},
	LANDING_SNIPPETS: {
		BASE: '/v2/landing-snippets'
	},
	MAILINGS_NEW: {
		MANUAL_MAILINGS: '/v2/mailings-new/manual-mailings',
		TRIGGERED_MAILINGS: '/v2/mailings-new/triggered-mailings',
		IMAGES: '/v2/mailings-new/images',
		SEND_TEST: '/v2/mailings-new/send-test-email'
	},
	MAILING_EVENTS: {
		AFFILIATES: '/v2/mailing-events/affiliates'
	},
	DEFINED_REFERERS: {
		BASE: '/v2/defined-referers'
	},
	CAMPAIGNS: {
		BASE: '/v2/campaigns',
		PAYOUTS_LOOKUP: '/v2/campaigns/payouts-lookup',
		PAYOUTS: '/v2/campaigns/payouts'
	},
	POSTBACK_LOG: {
		BASE: '/v2/postback-log'
	},
	LANG_RULES: {
		BASE: '/v2/lang-rules',
		SINGLE: '/v2/lang-rules/{lang}'
	},
	GEO_RULES: {
		BASE: '/v2/geo-rules',
		SINGLE: '/v2/geo-rules/{code}'
	},
	POLLS: {
		BASE: '/v2/polls'
	},
	WM: {
		CONFIG: '/v2/wm/config',
		PURSES: '/v2/wm/purses',
		HISTORY: '/v2/wm/history',
		TRANSFER: '/v2/wm/transfer',
		PROTECTION: '/v2/wm/protection'
	},
	ADV_REQUESTS: {
		BASE: '/v2/adv-requests'
	},
	CONVERSIONS: {
		BASE: '/v2/conversions',
		WHITELISTED_IPS: '/v2/conversions/whitelisted-ips',
		STATUS: '/v2/conversions/status',
		BLACKLISTED_IPS: '/v2/conversions/blacklisted-ips',
		INCREASE_PAST_APPROVE: '/v2/conversions/increase-past-approve',
		REQUEST_GARANT: '/v2/conversions/request-garant',
		DAILY_APPROVE: '/v2/conversions/daily-approve',
		STATS_FOR_MANUAL_APPROVE: '/v2/conversions/stats-for-manual-approve',
		STATS_FOR_GARANT_APPROVE: '/v2/conversions/stats-for-garant-approve',
		MARK_FRAUD: '/v2/conversions/mark-fraud'
	},
	MANUAL_APPROVE_REQUEST: {
		BASE: '/v2/manual-approve-requests',
		TEAMS_REPORT: '/v2/manual-approve-requests/teams-report'
	},
	ARTIFICIAL_APPROVE_REQUESTS: {
		BASE: '/v2/artificial-approve-requests'
	},
	MANUAL_GUARANT_REQUEST: {
		BASE: '/v2/manual-garant-register',
		HISTORY: '/v2/manual-garant-register/{id}/history',
		EXPANDED: '/v2/manual-garant-register/{id}/expanded',
		LIMITED: '/v2/manual-garant-register/limited',
		LIMITED_ANALYSIS: '/v2/manual-garant-register/limited-analized'
	},
	GARANT_FORECAST: {
		BASE: '/v2/garant-forecast',
		EXPANDED: '/v2/garant-forecast/expanded'
	},
	DAILY_APPROVES: {
		BASE: '/v2/daily-approves'
	},
	FIN_REPORTS: {
		BASE: 'v2/analytics/fin-reports',
		MANUAL_ADJUSTMENTS: 'v2/analytics/manual-adjustments',
		INCREASE_APPROVE: 'v2/analytics/fin-reports/increase-approve',
		BALANCES_REPORT: 'v2/analytics/balances-report',
		ACCRUALS: 'v2/analytics/accruals',
		PAYOUT_REPORT: 'v2/analytics/payout-report'
	},
	MARKETING_REPORTS: {
		BASE: 'v2/analytics/marketing-reports'
	},
	LANDING_REPORTS: {
		BASE: 'v2/landing-reports'
	},
	AFFILIATE_REPORTS: {
		BASE: 'v2/analytics/affiliate-reports'
	},
	PROMO_REPORTS: {
		BASE: 'v2/analytics/promo-report',
		CONVERSION: 'v2/analytics/conversion-report'
	},
	RANKS_POINTS_REPORT: {
		BASE: 'v2/ranks-points-report'
	},
	DASHBOARD_VISITS: {
		BY_AFFILIATE: 'v2/dashboard-visits/affiliates/{id}'
	},
	BANNERS: {
		PUBLICATIONS: 'v2/banners/publications',
		CONTENTS: 'v2/banners/contents',
		IMAGES: 'v2/banners/images'
	},
	CUSTOM_POPUPS: {
		BASE: 'v2/custom-popups',
		IMAGES: 'v2/custom-popups/images',
		AFFILIATES: '/v2/custom-popups/affiliates'
	},
	BLOG: {
		ARTICLES: 'v2/blog/articles',
		ARTICLE_IMAGES: 'v2/blog/article-images',
		ARTICLE_TAGS: 'v2/blog/article-tags',
		ARTICLE_COMMENTS: 'v2/blog/article-comments'
	}
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/config/endpoints.js